import {ReactComponent as saladsIcon} from 'assets/icons/salad.svg'
import {ReactComponent as appetizersIcon} from 'assets/icons/appetizer.svg'
import {ReactComponent as mixplateIcon} from 'assets/icons/mixedplate.svg'
import {ReactComponent as maindishIcon} from 'assets/icons/maindish.svg'
import {ReactComponent as pastaIcon} from 'assets/icons/pasta.svg'
import {ReactComponent as hotdrinkIcon} from 'assets/icons/hotdrink.svg'
import {ReactComponent as colddrinkIcon} from 'assets/icons/colddrink.svg'
import {ReactComponent as softdrinkIcon} from 'assets/icons/soda.svg'
import {ReactComponent as juiceIcon} from 'assets/icons/freshjuice.svg'
import {ReactComponent as beersIcon} from 'assets/icons/beer.svg'
import {ReactComponent as wineIcon} from 'assets/icons/wine.svg'
import {ReactComponent as drinksIcon} from 'assets/icons/alcohol.svg'
import {ReactComponent as aperitifIcon} from 'assets/icons/apperitif.svg'
import {ReactComponent as snackIcon} from 'assets/icons/snacks.svg'
import {ReactComponent as crepeIcon} from 'assets/icons/crepe.svg'
import {ReactComponent as waffleIcon} from 'assets/icons/waffle.svg'
import {ReactComponent as icecreamIcon} from 'assets/icons/icecream.svg'
import {ReactComponent as cocktailsIcon} from 'assets/icons/cocktail.svg'
import {ReactComponent as brunchIcon} from 'assets/icons/omelette.svg'

export const categoryIcons = [
  {id:1,component:saladsIcon},
  {id:2,component:appetizersIcon},
  {id:3,component:mixplateIcon},
  {id:4,component:maindishIcon},
  {id:5,component:pastaIcon},
  {id:6,component:hotdrinkIcon},
  {id:7,component:colddrinkIcon},
  {id:8,component:softdrinkIcon},
  {id:9,component:juiceIcon},
  {id:10,component:beersIcon},
  {id:11,component:wineIcon},
  {id:12,component:drinksIcon},
  {id:13,component:aperitifIcon},
  {id:14,component:snackIcon},
  {id:15,component:crepeIcon},
  {id:16,component:waffleIcon},
  {id:17,component:icecreamIcon},
  {id:18,component:cocktailsIcon},
  {id:19,component:brunchIcon},
  ]
